<template>
    <div class="flex flex-wrap items-stretch justify-center gap-4 p-2">
        <component
            :is="item.href ? 'a' : 'div'"
            v-for="item in items"
            :key="item.key"
            v-bind="linkAttrs(item)"
            :aria-label="item.title"
            class="flex flex-col overflow-hidden rounded-2xl border border-stack-text bg-stack-text shadow-lg no-underline"
            :class="isDesktop ? 'w-48' : 'w-36'"
            @click="onClick"
        >
            <div
                class="w-full overflow-hidden"
                :class="isDesktop ? 'h-36' : 'h-28'"
            >
                <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    :alt="item.imageAlt"
                    class="h-full w-full object-cover"
                />
                <slot v-else name="placeholder" :item="item"></slot>
            </div>
        </component>
    </div>
</template>

<script>
export default {
    name: "SliderV3",
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    methods: {
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
